module.exports = __webpack_public_path__ + "img/pro_14.9e201715.jpg";